import { useInstancesByQuery } from 'hive-react-utils';
export function useWearables(patientID) {
    return useInstancesByQuery('ecarepd', 'wearableByPatientID', 'wearable', {}, patientID);
}
